// Build identity — inlined by CRA at build time from the values the npm build scripts put on the
// command line (REACT_APP_STAGE, REACT_APP_VERSION). Logged once at startup so QA can confirm which
// version and stage a browser is running; scripts/deploy.sh asserts the same values in the bundle.
export const APP_VERSION = process.env.REACT_APP_VERSION || 'local'
export const APP_STAGE = process.env.REACT_APP_STAGE || 'unknown'
export const BUILD_LABEL = `Aberdeen Hub v${APP_VERSION} · ${APP_STAGE}`
